import React, { memo } from 'react';

import { Box, Typography } from '@mui/material';
import LabelCDS from '@sharedCR/coreDesignSystem/LabelCDS';
import { LabelSize, LabelVariant } from '@sharedCR/coreDesignSystem/LabelCDS/LabelCDS.constants';
import PropTypes from 'prop-types';

import {
  taskTypeScopeOptionNameStyles,
  taskTypeScopeOptionStyles,
} from './TaskTypeScopeOption.styles';

const TaskTypeScopeOption = ({ option, optionText }) => (
  <Box sx={taskTypeScopeOptionStyles}>
    <Typography
      data-truncated
      className="truncate"
      sx={taskTypeScopeOptionNameStyles}
      variant="regular16"
    >
      {optionText}
    </Typography>
    {option.isGlobal && <LabelCDS size={LabelSize.S} title="Global" variant={LabelVariant.BRAND} />}
  </Box>
);

TaskTypeScopeOption.propTypes = {
  option: PropTypes.object.isRequired,
  optionText: PropTypes.string.isRequired,
};

export default memo(TaskTypeScopeOption);
